// src/api/report.api.ts
import { LabEarningsResponse, PREarningsResponse } from '@app/models/reports/ReportsResponse';
import { post, get } from './http.api';
import { LabEarningsRequest, PREarningsRequest } from '@app/models/reports/ReportsRequest';

export type SupportedReportTypes = 'lab';

// Laboratory Reports

export const getLabEarningsFilters = async (): Promise<LabEarningsResponse> => {
  try {
    const { data, status } = await get<LabEarningsResponse>(
      `/reports/lab/earnings_by_division_report`,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getLabEarningsReport = async (reportData: LabEarningsRequest) => {
  try {
    const response = await post<any>('/reports/lab/earnings_by_division_report', reportData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getLabTestCountFilters = async (): Promise<LabEarningsResponse> => {
  try {
    const { data, status } = await get<LabEarningsResponse>(`/reports/lab/counts_by_division_report`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getLabTestCountReport = async (reportData: LabEarningsRequest) => {
  try {
    const response = await post<any>('/reports/lab/counts_by_division_report', reportData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getLabSampleCountFilters = async (): Promise<LabEarningsResponse> => {
  try {
    const { data, status } = await get<LabEarningsResponse>(
      `/reports/lab/lab_services_by_division_report`,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getLabSampleCountReport = async (reportData: LabEarningsRequest) => {
  try {
    const response = await post<any>('/reports/lab/lab_services_by_division_report', reportData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

// Product Registration Reports

export const getPREarningsFilters = async (): Promise<PREarningsResponse> => {
  try {
    const { data, status } = await get<PREarningsResponse>(
      `/reports/product_registrations/earnings_by_pr_report`,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getPREarningsReport = async (reportData: PREarningsRequest) => {
  try {
    const response = await post<any>(
      '/reports/product_registrations/earnings_by_pr_report',
      reportData,
      undefined,
      true,
    );
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getPRCountsFilters = async (): Promise<any> => {
  try {
    const { data, status } = await get<PREarningsResponse>(
      `/reports/product_registrations/counts_by_pr_report`,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getPRCountsReport = async (reportData: any) => {
  try {
    const response = await post<any>('/reports/product_registrations/counts_by_pr_report', reportData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getRegByEstFilters = async (): Promise<any> => {
  try {
    const { data, status } = await get<PREarningsResponse>(
      `/reports/product_registrations/pr_locations_report`,
      undefined,
      true,
    );
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getRegByEstReport = async (reportData: any) => {
  try {
    const response = await post<any>('/reports/product_registrations/pr_locations_report', reportData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getDetailedEstReport = async (id: number) => {
  try {
    const response = await post<any>('/reports/product_registrations/pr_location_detail_report', id, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

// Import & Export Reports

export const getImpExpEarningsFilters = async (): Promise<any> => {
  try {
    const { data, status } = await get<PREarningsResponse>(`/reports/import_export/earnings_report`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getImpExpEarningsReport = async (id: number) => {
  try {
    const response = await post<any>('/reports/import_export/earnings_report', id, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getImpExpCompReport = async (id: number) => {
  try {
    const response = await post<any>('/reports/import_export/earnings_comparison_report', id, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getImpExpCountsFilters = async (): Promise<any> => {
  try {
    const { data, status } = await get<PREarningsResponse>(`/reports/import_export/counts_report`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getImpExpCountsReport = async (id: number) => {
  try {
    const response = await post<any>('/reports/import_export/counts_report', id, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getImpExpCountComReport = async (id: number) => {
  try {
    const response = await post<any>('/reports/import_export/counts_comparison_report', id, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getImpExpQtyByLevel = async (id: number) => {
  try {
    const response = await post<any>('/reports/import_export/qtys_report', id, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getConsByCountry = async (id: number) => {
  try {
    const response = await post<any>('/reports/import_export/country_wise_report', id, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getImpExpNomCountReport = async (id: number) => {
  try {
    const response = await post<any>('/reports/import_export/np_counts_report', id, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getImpExpTonageReport = async (id: number) => {
  try {
    const response = await post<any>('/reports/import_export/weightage_report', id, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getHReportFilters = async (): Promise<any> => {
  try {
    const { data, status } = await get<PREarningsResponse>(`/reports/finance/h_letter_account_report`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getHReport = async (id: number) => {
  try {
    const response = await post<any>('/reports/finance/h_letter_account_report', id, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getSummaryReportFilters = async (): Promise<any> => {
  try {
    const { data, status } = await get<PREarningsResponse>(`/reports/finance/summary_report`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getSummaryReport = async (id: number) => {
  try {
    const response = await post<any>('/reports/finance/summary_report', id, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getCPSummaryReportFilters = async (): Promise<any> => {
  try {
    const { data, status } = await get<PREarningsResponse>(`/reports/finance/cp_summary_report`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getCPSummaryReport = async (id: number) => {
  try {
    const response = await post<any>('/reports/finance/cp_summary_report', id, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

type ReportApiEntry = {
  getFilters: () => Promise<any>;
  generateReport: (data: any) => Promise<any>;
};

const reportKeyApiMap: Record<string, ReportApiEntry> = {
  // Laboratory Report Functions
  'earnings-by-divisions': {
    getFilters: getLabEarningsFilters,
    generateReport: getLabEarningsReport,
  },
  'earnings-by-divisions-nom-pay': {
    getFilters: getLabEarningsFilters,
    generateReport: getLabEarningsReport,
  },
  'test-count-by-divisions': {
    getFilters: getLabTestCountFilters,
    generateReport: getLabTestCountReport,
  },
  'test-count-by-divisions-nom-pay': {
    getFilters: getLabTestCountFilters,
    generateReport: getLabTestCountReport,
  },
  'sample-count-by-divisions': {
    getFilters: getLabSampleCountFilters,
    generateReport: getLabSampleCountReport,
  },
  'item-qty-by-divisions': {
    getFilters: getLabSampleCountFilters,
    generateReport: getLabSampleCountReport,
  },
  // Product Registration Report Functions
  'pr-earnings-by-departments': {
    getFilters: getPREarningsFilters,
    generateReport: getPREarningsReport,
  },
  'pr-count-by-departments': {
    getFilters: getPRCountsFilters,
    generateReport: getPRCountsReport,
  },
  'registrations-by-establishment': {
    getFilters: getRegByEstFilters,
    generateReport: getRegByEstReport,
  },
  'detailed-est-regs-report': {
    getFilters: getRegByEstFilters,
    generateReport: getDetailedEstReport,
  },
  // Import & Export Report Functions
  'imp-exp-earnings-by-departments': {
    getFilters: getImpExpEarningsFilters,
    generateReport: getImpExpEarningsReport,
  },
  'imp-exp-count-by-departments': {
    getFilters: getImpExpCountsFilters,
    generateReport: getImpExpCountsReport,
  },
  'imp-exp-earnings-comparison': {
    getFilters: getImpExpEarningsFilters,
    generateReport: getImpExpCompReport,
  },
  'imp-exp-counts-comparison': {
    getFilters: getImpExpCountsFilters,
    generateReport: getImpExpCountComReport,
  },
  'imp-exp-nominal-earnings': {
    getFilters: getImpExpEarningsFilters,
    generateReport: getImpExpEarningsReport,
  },
  'imp-exp-nominal-count': {
    getFilters: getImpExpEarningsFilters,
    generateReport: getImpExpNomCountReport,
  },
  'imp-exp-levels-by-qty': {
    getFilters: getImpExpCountsFilters,
    generateReport: getImpExpQtyByLevel,
  },
  'consignment-by-country': {
    getFilters: getImpExpCountsFilters,
    generateReport: getConsByCountry,
  },
  'imp-exp-tonnage': {
    getFilters: getImpExpCountsFilters,
    generateReport: getImpExpTonageReport,
  },
  //Finance Report Functions
  'h-form': {
    getFilters: getHReportFilters,
    generateReport: getHReport,
  },
  'summary-report': {
    getFilters: getSummaryReportFilters,
    generateReport: getSummaryReport,
  },
  'cashier-point-summary': {
    getFilters: getCPSummaryReportFilters,
    generateReport: getCPSummaryReport,
  },
};

export const getReportApiByKey = (reportKey: string): ReportApiEntry | undefined => {
  return reportKeyApiMap[reportKey];
};
